import { useSelector } from 'react-redux'

import {
  bisacSubjectsSelector,
  hasBisacSubjectsSelector,
  isVirtualStoreSelector
} from '@/selectors'
import { translate } from '@/utils/translations'

import BisacBadge from './BisacBadge'

const BisacSubjects = () => {
  const bisacSubjects = useSelector(bisacSubjectsSelector)
  const hasBisacSubjects = useSelector(hasBisacSubjectsSelector)
  const [bisacTierOne, bisacTierTwo] = bisacSubjects
  const isVirtualStore = useSelector(isVirtualStoreSelector)

  return (
    <If condition={hasBisacSubjects}>
      <div className='asset-bisac-subjects'>
        <h3 className='mb-3'>
          {translate('assets.index.subjects')}
        </h3>
        <ul className='pl-0 d-flex mb-0 list-unstyled'>
          <BisacBadge content={bisacTierOne} isAnchor={!isVirtualStore} />
          <BisacBadge content={bisacTierTwo} isAnchor={!isVirtualStore} />
        </ul>
      </div>
    </If >
  )
}

export default BisacSubjects
